var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85746 13.2368C6.36901 11.3763 4.59564 9.32986 3.62734 8.17938C3.3276 7.82324 3.22938 7.56261 3.17033 7.10351C2.96811 5.53151 2.86701 4.74551 3.32795 4.23811C3.7889 3.73071 4.60404 3.73071 6.23433 3.73071H17.7657C19.396 3.73071 20.2111 3.73071 20.672 4.23811C21.133 4.74551 21.0319 5.53151 20.8297 7.10352C20.7706 7.56262 20.6724 7.82325 20.3726 8.17938C19.403 9.33133 17.6261 11.3814 15.1326 13.2442C14.907 13.4128 14.7583 13.6874 14.7307 13.9921C14.4837 16.7227 14.2559 18.2183 14.1141 18.9749C13.8853 20.1964 12.1532 20.9313 11.226 21.587C10.6741 21.9773 10.0043 21.5127 9.93278 20.9085C9.79643 19.7568 9.53961 17.4171 9.25927 13.9921C9.23409 13.6846 9.08486 13.4068 8.85746 13.2368Z",
    stroke: "#000F30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.9bd00c5b8184b24d67d53aae3bc97979.svg";
export { ForwardRef as ReactComponent };